export class PhysicianDesktopLabProcedure {
    EncounterId: number;
    HasAnyInfeciousLabResult: boolean;
    HasAnyReleasedLabResult: boolean;
}
